import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

/** @param {any} props */
export default function CardImagePlaceholder({ className = '', size }) {
  return (
    <div
      className={classnames(
        'bg-gray-200 br4 w-100 flex-none flex items-center justify-center',
        className
      )}
      style={{
        height: size,
        width: size
      }}
    >
      <div className="br-100 bg-white ph3 pv3">
        <Icon
          name="fetch-dog"
          width="24px"
          height="24px"
          className="secondary"
        />
      </div>
    </div>
  );
}

CardImagePlaceholder.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string.isRequired
};
